import React from "react";
import {Label, Pane, Table, TableRow, toaster} from "evergreen-ui";
import {useDispatch} from "react-redux";

export default function CoefficientsComponent({
    isFullInfo,
    coefficients,
    onSelectA,
    onSelectB,
    onSelectC,
    onSelectD
}) {
    const dispatch = useDispatch();

    const [isAValid, setIsAValid] = React.useState(true)
    const [isBValid, setIsBValid] = React.useState(true)
    const [isCValid, setIsCValid] = React.useState(true)
    const [isDValid, setIsDValid] = React.useState(true)

    function onChange(val, action, validSetter) {
        const isInt = Number.isInteger(Number(val))
        validSetter(isInt)

        if (isInt) {
            dispatch(action(val))
        } else {
            dispatch(action(""))
        }
    }

    function isCoeffValid(coeff) {
        return Number.isInteger(Number(coeff))
    }

    function setVal(val, action) {
        dispatch(action(val))
    }

    return (
        <Pane width={300}>
            <Label>Коэффициенты для расчета уравнения</Label>
            <Table.Head>
                <Table.TextHeaderCell textAlign={"center"}>Коэффициент</Table.TextHeaderCell>
                <Table.TextHeaderCell textAlign={"center"}>Значение</Table.TextHeaderCell>
            </Table.Head>
            <Table.Body>
                <TableRow>
                    <Table.TextHeaderCell textAlign={"center"}>
                        <b style={{color: "black"}}>
                            A
                        </b>
                </Table.TextHeaderCell>

                <Table.EditableCell disabled={isFullInfo}
                                    textAlign={"center"}
                                    placeholder={"Введите значение"}
                                    onChange={val => setVal(val, onSelectA)}
                >

                    {coefficients.A}
                </Table.EditableCell>

                </TableRow>
                <TableRow>
                    <Table.TextHeaderCell textAlign={"center"}>
                        <b style={{color: "black"}}>
                        B
                        </b>
                    </Table.TextHeaderCell>
                    <Table.EditableCell placeholder={"Введите значение"}
                                        disabled={isFullInfo}
                                        textAlign={"center"}
                                        onChange={val => setVal(val, onSelectB)}>
                        {coefficients.B}
                    </Table.EditableCell>
                </TableRow>
                <TableRow>
                    <Table.TextHeaderCell textAlign={"center"}>
                        <b style={{color: "black"}}>
                        C
                        </b>
                    </Table.TextHeaderCell>
                    <Table.EditableCell placeholder={"Введите значение"}
                                        disabled={isFullInfo}
                                        textAlign={"center"}
                                        onChange={val => setVal(val, onSelectC)}>
                        {coefficients.C}
                    </Table.EditableCell>
                </TableRow>
                <TableRow>
                    <Table.TextHeaderCell textAlign={"center"}>
                        <b style={{color: "black"}}>
                        D
                        </b>
                    </Table.TextHeaderCell>
                    <Table.EditableCell placeholder={"Введите значение"}
                                        disabled={isFullInfo}
                                        textAlign={"center"}
                                        onChange={val => setVal(val, onSelectD)}>
                        {coefficients.D}
                    </Table.EditableCell>
                </TableRow>
            </Table.Body>
        </Pane>
    );
}

function isCoeffValid(coeff) {
    return coeff != null && (coeff+"").trim() !== "" && Number.isInteger(Number(coeff))
}

export function checkCoefficients(coefficients, equation) {
    const wrongCoeffs = []

    if (equation.includes('A') && (!coefficients.A || !isCoeffValid(coefficients.A))) {
        wrongCoeffs.push('A')
    }
    if (equation.includes('B') && (!coefficients.B || !isCoeffValid(coefficients.B))) {
        wrongCoeffs.push('B')
    }
    if (equation.includes('C') && (!coefficients.C || !isCoeffValid(coefficients.C))) {
        wrongCoeffs.push('C')
    }
    if (equation.includes('D') && (!coefficients.D || !isCoeffValid(coefficients.D))) {
        wrongCoeffs.push('D')
    }

    if (wrongCoeffs.length === 0) {
        return true
    } else {
        toaster.danger("Следующие коэффициенты уравнения должны быть целыми числами: " + wrongCoeffs.join(" ,") + ".")
        return false
    }
}

export function checkCoefficientsWithoutPush(coefficients, equation) {
    const wrongCoeffs = []

    if (equation.includes('A') && (!coefficients.A || !isCoeffValid(coefficients.A))) {
        wrongCoeffs.push('A')
    }
    if (equation.includes('B') && (!coefficients.B || !isCoeffValid(coefficients.B))) {
        wrongCoeffs.push('B')
    }
    if (equation.includes('C') && (!coefficients.C || !isCoeffValid(coefficients.C))) {
        wrongCoeffs.push('C')
    }
    if (equation.includes('D') && (!coefficients.D || !isCoeffValid(coefficients.D))) {
        wrongCoeffs.push('D')
    }

    return wrongCoeffs.length === 0;
}
